import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form, FormInput, FormSelect } from '../../core/Formikfy';
import { db } from '../../firebase';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { DropzoneArea } from 'material-ui-dropzone';
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({}));

const BlogEditDialog = (props) => {
  const [open, setOpen] = React.useState(false);
  const [impactItem, setImpactItem] = useState<any>({});
  const [impactItemList, setImpactItemList] = useState<any>([]);
  const { openDialog, dialogBoxHandler, defaultValues } = props;
  const classes = useStyles();

  return (
    <Dialog
      disableEnforceFocus
      open={openDialog}
      onClose={dialogBoxHandler}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Update Blog</DialogTitle>
      <Form
        initialValues={{
          positionName: '',
        }}
        onSubmit={async (data) => {
          try {
          } catch (e) {
            console.error(e);
          }
        }}
      >
        <DialogContent>
          <DialogContentText>
            Enter blog information to update the details
          </DialogContentText>
          <div style={{ marginLeft: '10px' }}>
            <FormInput
                type="text"
                label="Title"
                name="title"
                variant="standard"
                fullWidth={true}
            />
          </div>
          <div style={{ marginLeft: '10px' }}>
            <FormInput
              type="text"
              label="Sub Title"
              name="subTitle"
              variant="standard"
              fullWidth={true}
            />
          </div>
          <div style={{ marginLeft: '10px' }}>
            <FormInput
                type="text"
                label="Description"
                name="description"
                multiline={true}
                variant="standard"
                fullWidth={true}
            />
          </div>
          <div style={{ margin: '10px' }}>
            <DialogContentText>
              Upload Images
            </DialogContentText>
            <DropzoneArea
                onChange={(files) => console.log('Files:', files)}
                acceptedFiles={['image/*']}
                maxFileSize={5000000}
                filesLimit={3}
            />
          </div>
          <div style={{ marginLeft: '10px' }}>
            <DialogContentText>
              Add Impact
            </DialogContentText>
            <Grid container spacing={3}>
              <Grid item xs={4}>
              <FormInput
                  type="text"
                  label="Heading"
                  name="heading"
                  variant="standard"
                  onChange={(e)=>setImpactItem(prev=>prev.heading=e)}
                  fullWidth={true}
              />
              </Grid>
              <Grid item xs={5}>
                <FormInput
                    type="text"
                    label="Sub Heading"
                    name="subHeading"
                    variant="standard"
                    onChange={(e)=>setImpactItem(prev=>prev.subHeading=e)}
                    fullWidth={true}
                />
              </Grid>
              <Grid item xs={3}>
                <Button variant="contained" color="secondary" onClick={e => console.log(impactItem)}>
                  Add
                </Button>
              </Grid>
                  {/*// setImpactItemList(prev => [...prev, impactItem])}*/}
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {}} color="primary">
            Cancel
          </Button>
          <Button type="submit" onClick={() => {}} color="primary">
            Update
          </Button>
          <IconButton
            style={{ right: '0', top: '0', position: 'absolute' }}
            color="primary"
            onClick={() => {}}
          >
            <DeleteIcon />
          </IconButton>
        </DialogActions>
      </Form>
    </Dialog>
  );
};
export default BlogEditDialog;
